const CustomerNoteDisplayModeEnum = {
    Always: 'Always',
    UntilRelevantMonth: 'UntilRelevantMonth',
    DuringRelevantMonth: 'DuringRelevantMonth',
    AfterRelevantMonth: 'AfterRelevantMonth',
}

export default CustomerNoteDisplayModeEnum;